import ThumbUp from "./SVG/thumb-up.svg?react";

const ThumbUpIcon = () => {
  return <ThumbUp />;
};

export default ThumbUpIcon;
